module.exports = __webpack_public_path__ + "static/media/train.dc005663.svg";